import cx                                     from 'classnames';
import React, { PropTypes }                   from 'react';
import VideoActions                           from 'actions/video_actions';
import { imageServer, envCheck, isLocal }     from 'utils/util';
import { isMobile }                           from 'utils/util';
import $                                      from 'jquery';


export default React.createClass({
    displayName: 'Player.PlaylistItem',
    propTypes: {
        onTouchEnd: PropTypes.func,
        onClick: PropTypes.func,
        isSelected: PropTypes.bool,
        video: PropTypes.object,
        index: PropTypes.number,
        hasViewed: PropTypes.bool,
        duration: PropTypes.number,
        enabled: PropTypes.bool,
        isLocked: PropTypes.bool,
        lockedStyle: PropTypes.string,
        isMobileItem: PropTypes.bool
    },
    isTouchMove: false,
    touchTimeout: null,
    selectVideo(e) {
        if(this.props.enabled === false) {
            return;
        }
        e.preventDefault();
        if(!this.props.isSelected) {
            if(this.props.onClick && !isMobile()) {
                this.props.onClick(e);
            } else if(isMobile() && $('body').hasClass('has-mobile-menu')) {
                $(window).trigger('mobmenu:close');
            }
            VideoActions.selectVideo(this.props.video, this.props.index);
            VideoActions.start();
        }
    },
    onTouchMove(e) {
        if(this.isTouchMove) return;
        else this.isTouchMove = true;
        this.touchTimeout = window.setTimeout(() => {
            this.isTouchMove = false;
            window.clearTimeout(this.touchTimeout);
        }, 300);
    },
    onTouchEnd(e) {
        if(!this.isTouchMove) {
            this.selectVideo(e);
        }
    },
    render() {//console.log('grayout: '+this.props.isLocked+'('+this.props.lockedStyle+')');
        const curVideo = this.props.index + 1,
            env = isLocal()? '.proddev':envCheck(),
            playBtn = `${imageServer(env)}/pi/features/brandplay/play-btn.png`;

        let title   = (<div className="advertisment">INFORMATION FROM INDUSTRY</div>),
            content = null,
            legend  = null,
            classNames = null,
            posterPlayBTN = (<div className="poster-play-btn">
                <img src={ playBtn }/>
            </div>);

        if(this.props.video.hasOwnProperty("events")){
            if(this.props.video.events[0].lockDisplay === 'hide'){
                classNames = cx({
                    'video-player-playlist-item': true,
                    'is-selected': this.props.isSelected,
                    'has-viewed': this.props.hasViewed,
                    'hide-playlist': this.props.isLocked,
                    'mobile-item': this.props.isMobileItem
                });
            } else {
                classNames = cx({
                    'video-player-playlist-item': true,
                    'is-selected': this.props.isSelected,
                    'has-viewed': this.props.hasViewed,
                    'gray-out': this.props.isLocked,
                    'mobile-item': this.props.isMobileItem
                });
            }
        }

        if(!this.props.video.isAdvertisement) {
            if (this.props.video.label && this.props.video.label !== null) {
                title=(<span className="low-light"> {this.props.video.label}: </span>);
            } else {
                title = (<span className="low-light"> {`CHAPTER ${curVideo}`}: </span>);
            }
        }
        if(this.props.isSelected) {
            if(this.props.video.label && this.props.video.label !== null) {
                title=(<span className="low-light"> {this.props.video.label}: </span>);
            } else {
                title = (<span className="low-light"> {`CHAPTER ${curVideo}`}: </span>);
            }
        }
        if(this.props.video.title.length > 45) {
            content = (<div className="video-title">
                {title}<span className="title"
                             dangerouslySetInnerHTML={{ __html: this.props.video.title }}></span>
            </div>);
        } else {
            content = (<div className="video-title">
                {title}<span className="title" dangerouslySetInnerHTML={{ __html: this.props.video.title }}></span>
            </div>);
        }

        const videoTitleClasses = cx({
                'video-title': true,
                'now_playing_color': true
            }),
            posterClasses = cx({
                'poster-play-btn': true,
                'hide-poster-play': true
            });

        if(this.props.hasViewed) {
            legend = <div className="watched">WATCHED</div>;
        }

        if(this.props.isSelected) {
            legend = <div className="now-playing"><span className="now-playing-txt">NOW PLAYING</span></div>;
            if(this.props.video.title.length > 45) {
                content = (<div className={videoTitleClasses}>
                    {title}<span className="title"
                                 dangerouslySetInnerHTML={{ __html: this.props.video.title }}></span>

                </div>);
            } else {
                content = (<div className={videoTitleClasses}>
                    {title}<span className="title"
                                 dangerouslySetInnerHTML={{ __html: this.props.video.title }}></span>
                </div>);
            }
            posterPlayBTN = (<div className={posterClasses}>
                <img src={ playBtn }/>
            </div>);
        }
        const { thumbnailFileName, thumbnail } =  this.props.video;
        if(thumbnailFileName.search(thumbnail) === -1) {
            if(thumbnail.search('//') === -1) {
                this.props.video.thumbnail = `${imageServer(env)}/${this.props.video.thumbnail.replace(/^en\//, '')}` + this.props.video.thumbnailFileName;
            } else {
                this.props.video.thumbnail = `${this.props.video.thumbnail.replace(/^en\//, '')}`;
                if(this.props.video.thumbnail.indexOf(this.props.video.thumbnailFileName) === -1 ) this.props.video.thumbnail += this.props.video.thumbnailFileName;
            }
        }
        if(this.props.isMobileItem) {
            return (
                <div className={classNames} onClick={this.selectVideo} onTouchEnd={this.onTouchEnd} onTouchMove={this.onTouchMove}>
                    {content}
                </div>
            );
        } else {
            return (
                <div className={classNames} onClick={this.selectVideo} onTouchEnd={this.onTouchEnd} onTouchMove={this.onTouchMove}>
                    {content}
                    {posterPlayBTN}
                    <div className="poster">
                        <img className="posterThumb" src={this.props.video.thumbnail} />
                    </div>
                    {legend}
                </div>
            );
        }
    }
});



// WEBPACK FOOTER //
// ./modules/components/player/playlist_item.jsx